import React, { useEffect, useState } from 'react';
import { Loader, MessageCard } from '@simplybenefits/sb-ui-library';
import { getAccountNotes } from '../../actions/accounts.js';

/**
 * @returns {JSX.Element}
 * @constructor
 */
const AccountNotesForMember = ({ accountID, classID, divisionID }) => {
    const [ accountNotesForUser, setAccountNotes ] = useState([]);
    const [ loading, setLoading ] = useState(true);

    useEffect(async () => {
        const notes = await getAccountNotes(accountID, classID, divisionID);

        setAccountNotes(notes);
        setLoading(false);
    }, [ accountID, classID, divisionID ]);

    if (accountNotesForUser.length === 0) {
        return null;
    }

    let notes = '';

    for (const note of accountNotesForUser) {
        if (note.status.toUpperCase() === 'EXPIRED') {
            // eslint-disable-next-line no-continue
            continue;
        }

        notes += `• ${ note.body }\n`;
    }

    return (
        <div>
            {
                loading ?
                    <Loader isContainer/>
                    :
                    <MessageCard
                        isError={ true }
                        title="This member has exceptions!"
                        subtitle={ notes }
                        formatted={ true }
                    />
            }
        </div>
    );
};

export default AccountNotesForMember;